export function tapJumpDistance(speed: number, jumpV: number, gravity: number): number {
  return speed * ((2 * jumpV) / gravity);
}

/** Points for one clean landing. First house is 1. Streak 3 is worth 3, and so on. */
export function landingPoints(streakAfterLanding: number): number {
  return Math.max(1, streakAfterLanding);
}

export function applyLanding(score: number, streak: number): {
  score: number;
  streak: number;
  points: number;
} {
  const nextStreak = streak + 1;
  const points = landingPoints(nextStreak);
  return { score: score + points, streak: nextStreak, points };
}

export function resetStreak(streak: number): number {
  return streak > 0 ? 0 : streak;
}

/** ISO week id in America/New_York, e.g. 2026-W37. Week starts Monday. */
export function easternWeekId(now = new Date()): string {
  const fmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const parts = fmt.formatToParts(now);
  const year = Number(parts.find((p) => p.type === "year")?.value);
  const month = Number(parts.find((p) => p.type === "month")?.value);
  const day = Number(parts.find((p) => p.type === "day")?.value);
  const utc = Date.UTC(year, month - 1, day);
  const date = new Date(utc);
  const dow = date.getUTCDay();
  const thursday = new Date(utc);
  thursday.setUTCDate(date.getUTCDate() + (4 - (dow === 0 ? 7 : dow)));
  const isoYear = thursday.getUTCFullYear();
  const jan1 = Date.UTC(isoYear, 0, 1);
  const week = Math.ceil(((thursday.getTime() - jan1) / 86400000 + 1) / 7);
  return `${isoYear}-W${String(week).padStart(2, "0")}`;
}
